import { DataType } from '..';

const notFoundLabels = {
  emailUs: 'Email us at info@neberox.com to apply for a test account',
  waitlist: 'Join the waitlist',
};

const genericLabels = {
  contactUs: 'Contact Us',
  logout: 'Logout',
  month: 'Month',
  na: 'N/A',
  add: '+ Add',
  terms: 'T & C',
  privacy: 'Privacy Policy',
  reports: 'Reports',
  save: 'Guardar',
  and: 'y',
};

const reportLabels = {
  searchPlaces: 'Search Places',
  typePlace: 'Type Place name',
  description: 'Generate Reply',
  addKeywords: 'Add Keywords',
  generate: 'Generate Report',
  info: 'Genera una vista competitiva rápida para una ubicación. Proporciona un lugar, radio y palabras clave para ver la fuerza relativa y los promedios de competidores.',
};

const loginLabels = {
  signIn: 'Sign in',
  detail: 'With your business google account',
  new: 'New to Syntraxis?',
};

const dashboardLabels = {
  keywords: 'Keywords',
  toDo: 'To-Do List',
  reviews: 'Reviews',
  businessLocation: 'Business Location',
};

const keywordLabels = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  delete: 'Delete Keyword',
  performanceStats: 'Estadísticas de rendimiento',
  typeKeyword: 'Type Keyword',
  overallStrength: 'Over all profile strength',
  reviewStats: 'Review Statistics',
  reviewStatsInfo:
    'Resumen de sentimiento y conteos de reseñas para identificar tendencias rápidamente y detectar áreas que requieren atención.',
  rankings: 'Keywords Rankings',
  description:
    'Keywords for local SEO for a place can vary depending on the specific location, offerings, and target audience. These are some of the keywords found relevant to your business. Keeping track of the progress is key in our system 👍',
  processingKeywords: 'Processing Keywords',
  researchKeywords:
    'The keywords for your businesses are still being researched by the simiplicty team',
  info: 'Supervisa el rendimiento de las palabras clave, las estadísticas de reseñas y la fuerza general del perfil. Usa esta información para priorizar SEO y medir el progreso.',
  performanceStatsInfo:
    'Sigue métricas clave de interacción en el tiempo (llamadas, visitas al sitio, indicaciones, impresiones) para entender el impacto del marketing.',
};

const statsLabels = {
  movementInfo: '(since first login)',
  competitorsText: (count: DataType) => `Out of ${count} local competitors`,
  placesRankingText: (ranking: DataType) => `${ranking} places`,
};

const reviewLabels = {
  title: 'Reply Recent Reviews',
  stars: 'Stars',
  generateReply: 'Generate Reply',
  info: 'Consulta y gestiona tus reseñas recientes de Google. Usa el interruptor para ver solo las que no tienen respuesta. Haz clic en una reseña para abrir los detalles, generar una respuesta con IA y publicarla.',
};

const todoLabels = {
  edit: 'Edit item',
  delete: 'Delete item',
  progress: 'Your checklist progress',
  essentialInfo: 'Essential Information',
  mustHaves: 'Syntraxis Must Haves',
  addChecklist: 'Type checklist item',
};

const alertLabels = {
  signout: 'Are you sure you want to sign out?',
  deleteToDo: (title: DataType) =>
    `Are you sure, you want to delete "${title}"`,
  deleteKeyword: (keyword: DataType) =>
    `Are you sure, you want to delete ${keyword} keyword`,
};

const chartLabels = {};

const settingsLabels = {
  title: 'Guías de respuesta de reseñas',
  placeholder:
    'Escribe cualquier guía sobre cómo deben redactarse las respuestas (tono, hacer/no hacer, etc.)',
  saving: 'Guardando…',
  autoReplyLabel: 'Respuesta automática a nuevas reseñas',
  info: 'Define el tono y las reglas de las respuestas generadas por IA. Activa la respuesta automática para contestar cuando lleguen nuevas reseñas (requiere automatización en el backend).',
  qrTitle: 'Código QR de Reseñas de Google',
  qrInfo:
    'Escanea o imprime este código para enlazar directamente a la página de reseñas o mapas de tu negocio.',
  qrDownload: 'Descargar PDF',
  qrAlt: 'Código QR de reseñas de Google',
  reviewLandingLabel: 'Mensaje de la página intermedia',
  reviewLandingPlaceholder: 'Reseña y recibe 20% de descuento',
  checkinsBrandingTitle: 'Marca y oferta del email',
  checkinsBrandingInfo:
    'Sube tu logo y define los detalles de la oferta que aparecerán en el email de bienvenida después del check-in.',
  checkinsEmailLogoLabel: 'Logo',
  checkinsEmailLogoHelp:
    'Se muestra en la parte superior del email de bienvenida.',
  checkinsOfferPercentLabel: 'Oferta (% de descuento)',
  checkinsOfferPercentPlaceholder: '20',
  checkinsOfferValidityLabel: 'Validez de la oferta',
  checkinsOfferValidityPlaceholder: 'Válida por 14 días después de recibirla',
  checkinsOfferCodeLabel: 'Código de canje',
  checkinsOfferCodePlaceholder: 'BIENVENIDO20',
  checkinsOfferDetailsLabel: 'Condiciones / detalles',
  checkinsOfferDetailsPlaceholder: 'Uso único, solo en tienda.',
  checkinsEmailTemplateHint:
    'Estos valores se insertan en la plantilla del email que reciben los invitados después del check-in.',
  uploadLogoCta: 'Subir logo',
  logoUploading: 'Subiendo…',
  logoPlaceholder: 'Logo',
  logoUploadFailed: 'No se pudo subir el logo ahora.',
  logoLocationRequired: 'Elige una ubicación antes de subir un logo.',
  checkinsTitle: 'Registros QR',
  checkinsSubtitle:
    'Las personas que escanearon tu QR y completaron el formulario aparecen aquí.',
  checkinsSearchPlaceholder: 'Busca nombre o correo',
  checkinsRangeLabel: 'Rango de tiempo',
  checkinsRange7d: 'Últimos 7 días',
  checkinsRange30d: 'Últimos 30 días',
  checkinsRangeAll: 'Todo el tiempo',
  checkinsOptInOnly: 'Solo opt-in',
  checkinsStatTotal: 'Registros totales',
  checkinsStatOptIn: 'Con opt-in',
  checkinsStatRecent: 'Esta semana',
  checkinsSelectLocation: 'Elige una ubicación para ver los registros QR.',
  checkinsEmptyTitle: 'Sin registros aún',
  checkinsEmptySubtitle:
    'En cuanto los clientes escaneen y envíen el formulario, aparecerán aquí.',
  checkinsUnknownVisitor: 'Visitante',
  checkinsOptInChip: 'Opt-in',
  checkinsNoOptInChip: 'Sin opt-in',
  checkinsSendOne: 'Enviar promo',
  checkinsSendCta: 'Enviar promoción',
  checkinsRefresh: 'Actualizar',
  checkinsPromoTitle: 'Enviar promoción',
  checkinsPromoBody: (count: DataType) =>
    `Esto irá a ${count} contacto(s) de tu lista filtrada.`,
  checkinsPromoSubject: 'Asunto',
  checkinsPromoMessage: 'Mensaje',
  checkinsPromoSend: 'Enviar',
  checkinsPromoSending: 'Enviando…',
  checkinsPromoCancel: 'Cancelar',
  checkinsPromoSuccess: (count: DataType) =>
    `Promoción encolada para ${count} contacto(s).`,
  checkinsPromoFailed: 'No se pudo enviar la promoción ahora mismo.',
  checkinsPromoDefaultSubject: 'Oferta VIP para visitantes recientes',
  checkinsPromoDefaultMessage:
    '¡Gracias por visitarnos! Aquí tienes una oferta para tu próxima visita.',
  checkinsWelcomeTitle: 'Correo de bienvenida de check-in',
  checkinsWelcomeInfo:
    'Correo predeterminado que se envía automáticamente a invitados que aceptan en el check-in.',
  checkinsWelcomeSubjectLabel: 'Asunto del correo',
  checkinsWelcomeSubjectPlaceholder: '¡Gracias por registrarte!',
  checkinsWelcomeMessageLabel: 'Mensaje del correo',
  checkinsWelcomeMessagePlaceholder:
    '¡Hola! Gracias por registrarte con nosotros. Aquí tienes una oferta para tu próxima visita.',
};

const billingLabels = {
  locationsBillingTitle: 'Suscripciones por ubicación',
  locationsBillingSubtitle:
    'Activa suscripciones por ubicación. Las nuevas suscripciones incluyen 7 días de prueba gratis.',
  noLocations:
    'No se encontraron ubicaciones. Conecta tu cuenta de Google para ver ubicaciones.',
  columnLocation: 'Ubicación',
  columnStatus: 'Estado',
  columnActions: 'Acciones',
  statusNoSubscription: 'Sin suscripción',
  statusTrial: 'Prueba',
  statusTrialExpired: 'Prueba finalizada',
  statusActive: 'Activa',
  activateWithTrial: 'Activar suscripción',
  billingCycleMonthly: 'Mensual',
  billingCycleYearly: 'Anual',
  planPopular: 'Popular',
  plans: {
    essential: {
      name: 'Esenciales',
      cta: 'Comenzar',
      description:
        'Plan base para proteger tu reputación y entender cómo nuevos clientes te descubren.',
      features: [
        'Flujo en vivo de nuevas reseñas de Google en tus ubicaciones',
        'Respuestas sugeridas con IA manteniendo un tono coherente',
        'Insights de palabras clave que generan visitas',
        'Reportes simples para accionar cada semana',
      ],
      prices: {
        monthly: { display: '£29', frequency: 'Por mes' },
        yearly: { display: '£299', frequency: 'Por año' },
      },
    },
    growth: {
      name: 'Crecimiento',
      cta: 'Comenzar',
      description:
        'Ideal para marcas en expansión que quieren gestionar reseñas y contenido social en un solo lugar.',
      features: [
        'Todo en Reseñas y Palabras clave',
        'Programar publicaciones en los principales canales',
        'Bandeja central para comentarios, mensajes y menciones',
        'Analítica de publicaciones (alcance, clics, engagement)',
        'Mejor hora para publicar según rendimiento previo',
      ],
      prices: {
        monthly: { display: '£59', frequency: 'Por mes' },
        yearly: { display: '£599', frequency: 'Por año' },
      },
    },
    elite: {
      name: 'Elite',
      cta: 'Comenzar',
      description:
        'Todo lo necesario para reputación, redes sociales y automatización a escala multi-sede.',
      features: [
        'Todo en Crecimiento',
        'Flujos automatizados de IA para campañas y seguimientos',
        'Paneles ejecutivos en tiempo real por ubicación',
        'Permisos por rol, auditoría y opciones SSO',
        'Onboarding dedicado y soporte estratégico',
      ],
      prices: {
        monthly: { display: '£149', frequency: 'Por mes' },
        yearly: { display: '£1,499', frequency: 'Por año' },
      },
    },
  },
};

const reviewLandingLabels = {
  fallbackMessage: 'Reseña y recibe 20% de descuento',
  headingInfo: 'Te dirigiremos a Google Reviews después de un breve registro.',
  fieldName: 'Nombre',
  fieldEmail: 'Correo electrónico',
  optIn: 'Envíame mi enlace de reseña y actualizaciones ocasionales.',
  continue: 'Continuar a Google Reviews',
  termsPrefix: 'Al continuar aceptas nuestros',
  missingUrl: 'Falta la URL de reseñas.',
  poweredBy: 'Desarrollado por',
};

const expenseLabels = {
  title: 'Registro de gastos',
  addExpenseTitle: 'Agregar un gasto',
  recentExpensesTitle: 'Gastos recientes',
  recentExpensesHelper:
    'Elimina en línea para quitar. Más filtros próximamente.',
  formDescriptionLabel: 'Descripción',
  formDescriptionPlaceholder:
    'ej., Café en grano, anuncios de Meta, comida del personal',
  formCategoryLabel: 'Categoría',
  formAmountLabel: 'Monto',
  formPaymentLabel: 'Pago',
  formAddButton: 'Agregar',
  listEmpty: 'Aún no hay gastos. Agrega el primero para seguir el gasto.',
  paymentFallback: 'Pago',
  totalSpend: 'Gasto total',
  totalSpendDescription: 'Suma de todos los gastos registrados',
  byCategory: 'Por categoría',
  byCategoryPlaceholder: 'Agrega gastos para ver totales por categoría.',
  aiOverline: 'Centro de Control de IA Syntraxis',
  aiHeadline: 'Escanea recibos y deja que la IA ordene tu gasto',
  aiDescription:
    'Captura una foto del recibo y crearemos el gasto automáticamente con categoría, monto y memo con marca de tiempo. Funciona bien para operaciones, compras y reembolsos.',
  chipReadReceipts: 'Leer recibos',
  chipPosMatching: 'Conciliación POS + tarjeta',
  chipRouteBudgets: 'Redirigir a presupuestos',
  chipAuditExport: 'Exportación lista para auditoría',
  captureButton: 'Capturar o subir recibo',
  reconcileButton: 'Pedir a la IA que concilie',
  receiptFallbackName: 'Recibo',
  receiptMemo: (vendor: DataType) => `${vendor} (recibo)`,
  receiptToast: (detail: DataType) => `Agregado ${detail} desde el recibo.`,
  categories: {
    Ops: 'Operaciones',
    Marketing: 'Marketing',
    Staff: 'Personal',
    Inventory: 'Inventario',
    Other: 'Otro',
  },
};

const campaignLabels = {
  title: 'Agente de Publicación Social',
  platform: 'Plataforma',
  platformPlaceholder: 'Selecciona plataforma',
  sourceMode: 'Fuente de Entrada',
  modeUrl: 'URL',
  modeText: 'Texto Libre',
  sourceUrl: 'URL Fuente',
  freeText: 'Ideas / Borrador del Post',
  hashtagsLimit: 'Límite de Hashtags',
  guidelines: 'Guías de Marca',
  desiredTone: 'Tono Deseado',
  toneFriendly: 'Amigable',
  toneProfessional: 'Profesional',
  toneWitty: 'Ingenioso',
  toneFormal: 'Formal',
  allowEmoji: 'Permitir Emoji',
  mediaOption: 'Fuente de Media',
  mediaNone: 'Ninguno',
  mediaAi: 'Generado por IA',
  mediaUpload: 'Subir',
  mediaUrl: 'Desde URL',
  imageUrl: 'URL de Imagen / Video',
  uploadFile: 'Subir Archivo',
  approxChars: 'Conteo Aproximado de Caracteres',
  history: 'Historial',
  output: 'Salida',
  schedule: 'Programación',
  run: 'Ejecutar',
  info: 'Configura y ejecuta un agente que genere publicaciones sociales. Proporciona una URL fuente, imagen opcional y longitud objetivo. Revisa salida, historial y programación.',
  historyEmpty:
    'Cada vez que hagas clic en ejecutar aparecerá un elemento en el historial ordenado por fecha de creación.',
  outputPlaceholder: 'La publicación generada aparecerá aquí.',
  schedulePlaceholder: 'Configura generaciones recurrentes (próximamente).',
  tabsAria: 'Pestañas de campañas',
  aboutAria: 'Acerca de campañas',
  ideasPlaceholder: 'Escribe ideas o pega texto...',
  guidelinesPlaceholder: 'Se aplicarán valores por defecto de Configuración',
  uploadButton: 'Subir Archivo',
  generatePost: 'Generar Publicación',
  generating: 'Generando…',
};

const assistantLabels = {
  promptTitle: 'Prueba un prompt',
  exampleTitle: 'Ejemplo en vivo',
  exampleBody:
    '¡Buenos días! Así va todo: los ingresos combinados de Toast + Square subieron 7% vs la semana pasada, pero la Sede B cayó 12% después de las 6pm. La calificación de Google bajó a 4.1 por dos reseñas sin responder. ¿Quieres que redacte respuestas y programe una historia de Instagram para recuperar el tráfico de la tarde?',
  disclaimerPrefix:
    'Syntraxis puede equivocarse. Verifica la información importante. Consulta nuestros',
  termsLink: 'Términos',
  thinking: 'Pensando…',
  errorMessage: 'No se pudo contactar al asistente ahora mismo.',
  dataTitle: 'Resultados estructurados',
  prompts: [
    {
      text: 'Resume ventas y afluencia de ayer en Toast y Square',
      category: 'insights',
    },
    {
      text: 'Crea una promo de fin de semana para Instagram + email con nuestro tono',
      category: 'marketing',
    },
    {
      text: 'Detecta sedes con calificaciones de Google en caída y sugiere respuestas',
      category: 'reviews',
    },
    {
      text: 'Encuentra SKUs a la baja y recomienda bundles para recuperarlos',
      category: 'inventory',
    },
    {
      text: 'Destaca las sedes con mejor desempeño y por qué superaron el promedio',
      category: 'insights',
    },
    {
      text: 'Crea un SMS de seguimiento en un clic para los grandes compradores de ayer',
      category: 'marketing',
    },
    {
      text: 'Detecta reembolsos o anulaciones anómalas en las últimas 24 horas',
      category: 'risk',
    },
    {
      text: 'Redacta respuestas para reseñas de 1 estrella usando nuestras guías',
      category: 'reviews',
    },
    {
      text: 'Arma un informe diario para el gerente con KPIs y alertas',
      category: 'ops',
    },
    {
      text: 'Prepara una publicación para Facebook + IG que siga nuestro tono de marca',
      category: 'marketing',
    },
  ],
};
const spanishTranslations = {
  chartLabels,
  reviewLabels,
  notFoundLabels,
  alertLabels,
  reportLabels,
  statsLabels,
  genericLabels,
  loginLabels,
  dashboardLabels,
  keywordLabels,
  todoLabels,
  settingsLabels,
  campaignLabels,
  reviewLandingLabels,
  billingLabels,
  assistantLabels,
  expenseLabels,
};

export default spanishTranslations;
